import { render } from "./UploadedFiles.vue?vue&type=template&id=3bb5048e&scoped=true"
import script from "./UploadedFiles.vue?vue&type=script&lang=js"
export * from "./UploadedFiles.vue?vue&type=script&lang=js"

import "./UploadedFiles.vue?vue&type=style&index=0&id=3bb5048e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb5048e"]])

export default __exports__